import "./App.css";
import { useParams } from "react-router-dom";
import TripDetailsSection from "../components/UI/trips/tripDetailsSection";

function Trip({ type }) {
  const { id } = useParams();

  return (
    <div className="App">
      <div className="App-container">
        <TripDetailsSection id={id} type={type} />
      </div>
    </div>
  );
}

export default Trip;
